import React, { ReactNode, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';

type ModalProps = {
  isOpen: boolean;
  onRequestClose: any;
  title?: string;
  children: ReactNode;
  innerDivStyles?: string;
  overflow?: string;
};

const Modal = ({
  isOpen,
  onRequestClose,
  title,
  children,
  innerDivStyles,
  overflow = 'overflow-auto'
}: ModalProps) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    if (contentRef.current) {
      setIsScrolled(contentRef.current.scrollTop > 0);
    }
  };

  const customShadow = 'inset 0 10px 10px -10px rgba(0, 0, 0, 0.2)';

  return (
    <>
      {isOpen ? (
        <>
          <div className="justify-center items-center flex fixed inset-0 z-50 outline-none focus:outline-none mt-20 mb-3 lg:my-3 mx-2 overflow-hidden">
            <div className="relative w-auto m-auto mx-auto max-w-7xl">
              {/*content*/}
              <div
                className={`${innerDivStyles} ${overflow} border-0 rounded-lg shadow-lg relative flex flex-col max-w-[1200px] w-full bg-primary2 outline-none focus:outline-none p-10 max-h-screen`}
              >
                {/*header*/}
                {title && (
                  <div className="flex items-start justify-between rounded-t pb-1">
                    <h3 className="text-3xl font-semibold mr-8">{title}</h3>
                    <Button
                      onClick={onRequestClose}
                      endIcon={<CloseIcon sx={{ borderRadius: 2 }} />}
                      variant="text"
                      size="small"
                      sx={{
                        color: 'black',
                        textTransform: 'none',
                        fontSize: '1rem',
                        '&:hover': {
                          backgroundColor: 'transparent'
                        }
                      }}
                    >
                      Close
                    </Button>
                  </div>
                )}
                {/*body*/}
                <div
                  className="relative pt-9 pb-10 flex-auto overflow-y-auto max-h-[70vh] lg:max-h-[80vh] pl-0.5"
                  ref={contentRef}
                  onScroll={handleScroll}
                  style={{
                    boxShadow: isScrolled ? customShadow : 'none'
                  }}
                >
                  {children}
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-neutral9"></div>
        </>
      ) : null}
    </>
  );
};

export default Modal;
